<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { useI18n } from '@/references/i18n';
import { RouteNames } from '@/router';

import type { InfoLayoutButton } from '@/components/layouts/InfoLayout.types';
import InfoLayout from '@/components/layouts/InfoLayout.vue';
import UiTitle from '@/components/ui/UiTitle.vue';

const { t } = useI18n();
const { replace } = useRouter();

const buttons = computed((): InfoLayoutButton[] => [
  {
    text: t('error404.cta'),
    mod: 'secondary',
    handler: () => {
      replace({ name: RouteNames.Home });
    }
  }
]);
</script>

<template>
  <InfoLayout :buttons="buttons">
    <template #image>
      <UiTitle :level="1">{{ t('error404.title') }}</UiTitle>
    </template>
    <template #default>
      {{ t('error404.description') }}
    </template>
  </InfoLayout>
</template>
